module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [_c('popup', {
    attrs: {
      "buttonStyle": "primary",
      "heading": "New Category",
      "showText": _vm.showText,
      "buttonText": "Category",
      "centerButton": true,
      "buttonIcon": "fa fa-file",
      "button-size": "mini"
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('el-form', {
    ref: "ff",
    attrs: {
      "model": _vm.file,
      "inline": false,
      "label-position": _vm.labelPos
    }
  }, [(_vm.titleList) ? _c('select-input', {
    attrs: {
      "prop": "title",
      "label": "Title",
      "list": _vm.titleList,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.file.title),
      callback: function($$v) {
        _vm.$set(_vm.file, "title", $$v)
      },
      expression: "file.title"
    }
  }) : _c('text-input', {
    attrs: {
      "prop": "title",
      "label": "Title",
      "placeholder": "Title in the files listing",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.file.title),
      callback: function($$v) {
        _vm.$set(_vm.file, "title", $$v)
      },
      expression: "file.title"
    }
  }), _vm._v(" "), (_vm.showCaption) ? _c('text-input', {
    attrs: {
      "prop": "caption",
      "label": "Caption",
      "placeholder": "If empty file name will be used",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.file.caption),
      callback: function($$v) {
        _vm.$set(_vm.file, "caption", $$v)
      },
      expression: "file.caption"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showRef) ? _c('text-input', {
    attrs: {
      "prop": "ref",
      "label": "Ref",
      "placeholder": "Any file ref (optional)",
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.file.ref),
      callback: function($$v) {
        _vm.$set(_vm.file, "ref", $$v)
      },
      expression: "file.ref"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isTowerCo() && _vm.isManager('project')) ? _c('el-form', {
    ref: "ff2",
    attrs: {
      "model": _vm.file,
      "inline": false,
      "label-position": _vm.labelPos
    }
  }, [(_vm.partyList) ? _c('select-input', {
    attrs: {
      "prop": "partyNo",
      "label": "Party",
      "list": _vm.partyList,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.file.partyNo),
      callback: function($$v) {
        _vm.$set(_vm.file, "partyNo", $$v)
      },
      expression: "file.partyNo"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stepList) ? _c('select-input', {
    attrs: {
      "prop": "step",
      "label": "Step",
      "list": _vm.stepList,
      "disabled": !_vm.editing
    },
    model: {
      value: (_vm.file.step),
      callback: function($$v) {
        _vm.$set(_vm.file, "step", $$v)
      },
      expression: "file.step"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-705015ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/FileAction.vue
// module id = 1634
// module chunks = 0